import * as React from 'react';
import { CheckboxGroup } from '@tock/shared/inputs';
import { consumer } from '@tock/coretypes';
import { generateAriaProps } from '@tock/shared/inputs/inputHelpers';
import QuizImageDisplay from './QuizImageDisplay';
import clsx from 'clsx';

interface Props {
  question: consumer.IPatronQuizQuestion;
  selectedOptionId?: Set<number>;
  onAnswer(optionId: Set<number>): void;
}

const MultiImageSelectQuizQuestion: React.FunctionComponent<Props> = ({
  question,
  selectedOptionId = new Set(),
  onAnswer,
}) => {
  const onChange = (optionId: number) => {
    if (selectedOptionId.has(optionId)) {
      selectedOptionId.delete(optionId);
      onAnswer(selectedOptionId);
    } else {
      selectedOptionId.add(optionId);
      onAnswer(selectedOptionId);
    }
  };

  return (
    <CheckboxGroup className="QuizModal-MultiImageSelect-container">
      {question.option?.map((option) => {
        const onChangeInternal = () => {
          return option.id && onChange(option.id);
        };
        return (
          option.id && (
            <ImageCheckbox
              key={`multiselect-${option.id}`}
              id={option.id.toString()}
              option={option}
              checked={selectedOptionId.has(option.id)}
              onClick={onChangeInternal}
              className={'MultiImageSelect-option'}
            />
          )
        );
      })}
    </CheckboxGroup>
  );
};

export default MultiImageSelectQuizQuestion;

interface ImageCheckboxProps {
  checked: boolean;
  label?: string;
  className?: string;
  disabled?: boolean;
  option: consumer.IPatronQuizQuestionOption;
  id: string;
  onClick(event: React.ChangeEvent<HTMLInputElement>): void;
}

const ImageCheckbox = ({
  option,
  checked,
  label,
  className,
  disabled,
  id,
  onClick,
}: ImageCheckboxProps) => {
  const ariaProps = generateAriaProps({
    label,
  });

  const componentClassname = clsx('Checkbox', className, {
    'is-checked': checked,
    'is-disabled': disabled,
  });

  return (
    <label htmlFor={id} className={componentClassname}>
      <input
        className="Input Checkbox-input"
        name={id}
        onChange={onClick}
        {...ariaProps}
        id={id}
        value={id}
        type="checkbox"
        checked={checked}
        aria-checked={checked}
      />
      <div className="Checkbox-indicator" role="checkbox" aria-checked={checked}>
        <QuizImageDisplay option={option} />
      </div>
    </label>
  );
};
